<template>
  <!-- 政策数据 -->
  <div class="policyResult">
    <div class="title">{{ "·" + policyResult.title }}</div>
    <div class="table">
      <div class="number fl table_row1">
        <span>文 号:</span>{{ policyResult.number }}
      </div>
      <div class="category fl table_row1">
        <span>主题分类:</span>{{ policyResult.category }}
      </div>
      <div class="releaseDepartment fl table_row1">
        <span>发布机构:</span>{{ policyResult.releaseDepartment }}
      </div>
      <div class="clear"></div>
      <div class="summary table_row2">
        <span>摘 要:</span>{{ policyResult.summary }}
      </div>
    </div>
    <div class="department_date">
      <div class="department fl">{{ policyResult.department }}</div>
      <div class="date fl">{{ policyResult.date }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-policy-result",
  components: {},
  props: {},
  data() {
    return {
      policyResult: {
        title: "对自治区十二届政协三次会议第0422号提案的答复",
        number: "内商外经函 2020 113号 ",
        category: "商贸、海关、旅游 ",
        releaseDepartment: "内蒙古自治区商务厅",
        summary:
          "内商外经函 2020 113号 内蒙古自治区商务厅 对自治区十二届政协三次会议第0422号提案的答复 自治区工商联 内商外经函 2020 113号 内蒙古自治区商务厅 对自治区十二届政协三次会议第0422号提案的答复 自治区工商联",
        department: "内蒙古自治区人民政府 ",
        date: "2020-08-01",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.clear {
  clear: both;
}

.table_row1 {
  height: 30px;
  width: 280px;
}
.table_row2 {
  height: 30px;
  width: 842px;
  border-top: 1px solid grey;
}

.policyResult {
  width: 853px;
  height: 115px;
  margin-top: 20px;
  .title {
    width: 440px;
    height: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgb(16, 115, 183);
  }
  span {
    display: inline-block;
    width: 70px;
    height: 30px;
    font-weight: bold;
    line-height: 30px;
    text-align-last: justify;
    color: black;
  }
  .table {
    width: 842px;
    height: 60px;
    border: 1px solid grey;
    margin-top: 10px;
    margin-left: 10px;
    .number {
      border-right: 1px solid grey;
      color: grey;
      overflow: hidden;
      word-wrap: break-word;
      display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
      -webkit-box-orient: vertical; // 从上到下垂直排列子元素
      -webkit-line-clamp: 1; // 表示显示的行数（需要结合上面两个属性）
    }
    .category {
      border-right: 1px solid grey;
      color: grey;

      overflow: hidden;
      word-wrap: break-word;
      display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
      -webkit-box-orient: vertical; // 从上到下垂直排列子元素
      -webkit-line-clamp: 1; // 表示显示的行数（需要结合上面两个属性）
    }
    .releaseDepartment {
      color: grey;

      overflow: hidden;
      word-wrap: break-word;
      display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
      -webkit-box-orient: vertical; // 从上到下垂直排列子元素
      -webkit-line-clamp: 1; // 表示显示的行数（需要结合上面两个属性）
    }
    .summary {
      color: grey;

      overflow: hidden;
      word-wrap: break-word;
      display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
      -webkit-box-orient: vertical; // 从上到下垂直排列子元素
      -webkit-line-clamp: 1; // 表示显示的行数（需要结合上面两个属性）
    }
  }
  .department_date {
    margin-left: 10px;
    color: grey;
    .date {
      margin-left: 600px;
      line-height: 20px;
    }
  }
}
</style>